import React, { useState } from "react";
import emailjs from "emailjs-com";
import {
  FaEnvelope, FaPhone, FaLinkedin, FaGithub,
  FaWhatsapp, FaMapMarkerAlt, FaGlobe, FaPaperPlane,
} from "react-icons/fa";
import "./Contact.css";

// ─── Direct contact chips ─────────────────────────────────────────────────
const CONTACTS = [
  {
    id: "email",
    icon: <FaEnvelope />,
    label: "Email",
    value: "elarebai.nl@gmail.com",
    href: "mailto:elarebai.nl@gmail.com",
    color: "#ff69b4",
  },
  {
    id: "whatsapp",
    icon: <FaWhatsapp />,
    label: "WhatsApp",
    value: "+216 50 102 891",
    href: "https://wa.me/21650102891",
    color: "#25D366",
  },
  {
    id: "phone",
    icon: <FaPhone />,
    label: "Phone",
    value: "+216 50 102 891",
    href: "tel:+21650102891",
    color: "#a0c8ff",
  },
  {
    id: "linkedin",
    icon: <FaLinkedin />,
    label: "LinkedIn",
    value: "linkedin.com/in/ela-rebai",
    href: "https://www.linkedin.com/in/ela-rebai-466b77226/",
    color: "#0A66C2",
  },
  {
    id: "github",
    icon: <FaGithub />,
    label: "GitHub",
    value: "github.com/ela2002",
    href: "https://github.com/ela2002",
    color: "#f0f0f0",
  },
  {
    id: "portfolio",
    icon: <FaGlobe />,
    label: "Portfolio",
    value: "elarebaiportfolio.web.app",
    href: "https://elarebaiportfolio.web.app",
    color: "#c87fff",
  },
  {
    id: "location",
    icon: <FaMapMarkerAlt />,
    label: "Location",
    value: "Tunis, Tunisia",
    href: null,
    color: "#ffb840",
  },
];

// ─── Contact ──────────────────────────────────────────────────────────────
const Contact = () => {
  const [formData, setFormData] = useState({ from_name: "", from_email: "", message: "" });
  const [status, setStatus] = useState(null); // null | "sending" | "sent" | "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .sendForm("service_v8ralip", "template_r9r3di7", e.target, "tX8aJ8aGsMyY-ZVi3")
      .then(
        () => {
          setStatus("sent");
          setFormData({ from_name: "", from_email: "", message: "" });
        },
        () => setStatus("error")
      );
  };

  return (
    <div className="contact-section">
      <h2 className="section-title">Contact</h2>
      <p className="contact-intro">
        Available for collaborations, opportunities, and conversations. Reach out through any channel below.
      </p>

      {/* ── Direct contact chips ──────────────────────────────────────────── */}
      <div className="contact-chips">
        {CONTACTS.map((c) =>
          c.href ? (
            <a
              key={c.id}
              href={c.href}
              target={c.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              className="contact-chip"
              style={{ "--chip-color": c.color }}
            >
              <span className="contact-chip__icon">{c.icon}</span>
              <div className="contact-chip__text">
                <span className="contact-chip__label">{c.label}</span>
                <span className="contact-chip__value">{c.value}</span>
              </div>
            </a>
          ) : (
            <div
              key={c.id}
              className="contact-chip contact-chip--static"
              style={{ "--chip-color": c.color }}
            >
              <span className="contact-chip__icon">{c.icon}</span>
              <div className="contact-chip__text">
                <span className="contact-chip__label">{c.label}</span>
                <span className="contact-chip__value">{c.value}</span>
              </div>
            </div>
          )
        )}
      </div>

      {/* ── Message form ──────────────────────────────────────────────────── */}
      <div className="contact-form-wrapper">
        <div className="contact-form-header">
          <FaPaperPlane /> Send a message
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Your Name</label>
            <input
              type="text"
              name="from_name"
              value={formData.from_name}
              onChange={handleChange}
              placeholder="Your name"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="from_email"
              value={formData.from_email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="What would you like to say?"
              rows={4}
              required
            />
          </div>
          <button
            type="submit"
            className="contact-submit-btn"
            disabled={status === "sending"}
          >
            {status === "sending" ? "Sending…" : "Send Message →"}
          </button>
          {status === "sent" && (
            <p className="contact-feedback contact-feedback--ok">
              ✓ Message sent! I'll get back to you soon.
            </p>
          )}
          {status === "error" && (
            <p className="contact-feedback contact-feedback--err">
              ✗ Something went wrong. Please try emailing directly.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
